"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loadable = void 0;
const React = require("react");
const Loadable = require("react-loadable");
function $Loadable(relativePath, importLoader, moduleIds) {
    return Loadable({
        loader: importLoader,
        loading: () => null,
        render(loadedLoadable, propsLoadable) {
            const arrayOfPath = relativePath.split('/');
            const name = arrayOfPath[arrayOfPath.length - 1];
            const Component = loadedLoadable[name];
            return React.createElement(Component, Object.assign({}, propsLoadable));
        },
        modules: [relativePath],
        webpack: moduleIds
    });
}
exports.Loadable = $Loadable;
//# sourceMappingURL=loadable.js.map